<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="修改课次" v-model="hideShow" width="600px" persistent>
			<v-card>
				<v-card-title>
					<span>修改排课</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-select :items="selectTeacherList" v-model="update.record.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
							<v-select :items="selectClassroomList" v-model="update.record.roomId" item-text="roomName"
								item-value="id" label="教室" dense outlined></v-select>
						</v-col>
						<v-col cols="4">
							<v-menu ref="menuclassDate" v-model="update.classDateMenu" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.classDate" label="上课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="update.record.classDate" locale="zh-cn" 
									@input="update.classDateMenu=false" no-title scrollable></v-date-picker>								
							</v-menu>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" :nudge-right="40"
								transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.timeFrom" label="上课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu5" v-model="update.record.timeFrom" full-width format="24hr"
									@click:minute="saveTimeFrom(update.record.timeFrom)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="2">
							<v-text-field label="时长(分钟)" type="number" v-model="update.record.timeMinutes" dense outlined @keyup="calItemTimeTo()">
							</v-text-field>
						</v-col>
						<v-col cols="3">
							<v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" :nudge-right="40"
								:return-value.sync="update.record.timeTo" transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.record.timeTo" label="下课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="menu6" v-model="update.record.timeTo" full-width format="24hr"
									@click:minute="$refs.menu6.save(update.record.timeTo)"></v-time-picker>
							</v-menu>
						</v-col>
			
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdateRecord" :disabled="update.submitting" :loading="update.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import global from "../config/global"
	import utils from "../config/utils"
	export default {
		name:"create-student",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			record:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					
					this.update.record.id = this.record.id;
					this.update.record.teacher = this.record.teacher;
					this.update.record.roomId = this.record.roomId;
					this.update.record.classDate = this.record.classDate;
					this.update.record.timeFrom = this.record.timeFrom;
					
					const ms = this.calMinutes(this.record.timeFrom,this.record.timeTo);
					
					
					
					this.update.record.timeMinutes = ms;
					
					this.calItemTimeTo();
					this.getClassroomListForSelect();
					this.getTeacherListForSelect();
				}
			}
		},
		data(){
			return {
				menu5:false,
				menu6:false,
				update: {
					dialog: false,
					classDateMenu:false,
					submitting:false,
					record: {
						id:"",
						teacher: "",
						roomId:"",
						classDate:"",
						timeFrom:"",
						timeTo:"",
						timeMinutes:"45"
					},
				},
				selectTeacherList:[],
				selectClassroomList:[],
				hideShow:this.show
			}
		},
		mounted() {
			console.log("update-record mounted");
			this.calItemTimeTo();
		},
		methods:{
			calMinutes(timeFrom,timeTo){
				if(!timeFrom || !timeTo){
					return "45";
				}
				
				let [toHour,toMinute] = timeTo.split(":");
				let [fromHour,fromMinute] = timeFrom.split(":");
				
				if (+toHour < +fromHour){
					toHour = +toHour + 24;
				}
				
				return (toHour - fromHour)* 60 + (toMinute - fromMinute)
				
			},
			calItemTimeTo(){
				// 选择开始时间 自动计算 结束时间
				
				
				// 必须有开始时间和时长
				if (!this.update.record.timeFrom || !this.update.record.timeMinutes){
					this.update.record.timeTo = "";
					console.log("no timeFrom or minutes");
					return
				}
				
				// 开始时间分割
				let arr = this.update.record.timeFrom.split(":");
				if (!arr || arr.length != 2){
					console.log("timeFrom invalid");
					return
				}
				// 构建一个日期 加上分钟数
				var sdate1 = new Date(2027,1,1,parseInt(arr[0]),parseInt(arr[1]),1);
				sdate1.setMinutes (sdate1.getMinutes () + parseInt(this.update.record.timeMinutes));
				
				// 新的时间和分钟
				let newHour = sdate1.getHours();
				let newMinutes = sdate1.getMinutes();
				
				// 左侧补齐2位
				const  hh = (Array(2).join(0) + newHour).slice(-2);
				const  mm = (Array(2).join(0) + newMinutes).slice(-2);
				
				var timeTo = hh+":"+mm;
				
				this.update.record.timeTo = timeTo;
				console.log("item.timeTo",timeTo);
				
			},
			saveTimeFrom(timefrom){
				this.update.record.timeFrom = timefrom;
				this.menu5 = false;
				this.calItemTimeTo();
			},
			cancel(){
				this.$emit("cancel","");
			},
			submitUpdateRecord() {
			
				if (!this.update.record.classDate) {
					this.$noty.error('上课日期不能为空');
					return
				}
				
				if (!this.update.record.roomId) {
					this.$noty.error('教室不能为空');
					return
				}
				if (!this.update.record.teacher) {
					this.$noty.error('老师不能为空');
					return
				}
				if (!this.update.record.timeFrom) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				if (!this.update.record.timeTo) {
					this.$noty.error('上课开始时刻不能为空');
					return
				}
				
				this.update.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/update`;
				let postData = {
					...this.update.record
				};
			
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.update.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.update.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submitting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			},
			
			getTeacherListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect(){
				const shopId = utils.getCurrentShopId();
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/classroom/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectClassroomList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style>
</style>
